<template>
  <div class="app-blog">
    <div class="container my-5">
      <div class="row" v-if="postsContentLoaded">
        <!-- <blogsidebar class="d-none d-md-block"></blogsidebar> -->
        <div class="col-md-3 d-none d-md-block">
          <div class="categ">
            <div
              class="input-group"
              style="display:flex; border: 0.8px solid #979797; border-radius:4px;margin-bottom:2rem;overflow:hidden "
            >
              <input
                type="text"
                class="searchp"
                placeholder="Search"
                style="border: 1px solid transparent;"
                aria-describedby="subscribeFormBtn"
                v-model="searchwords"
              />
              <div class="input-group-append">
                <button
                  class="input-group-text"
                  type="button"
                  id="subscribeFormBtn"
                  style="border: 1px solid transparent; background-color:transparent"
                  v-on:click="search($event)"
                >
                  <i class="ti-search"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- popular post -->
          <div class="categ py-3">
            <h4 class="cat-topic">POPULAR POST</h4>
            <div
              class="popular_post"
              v-for="(popularpost, i) in blogPosts.popularpost.slice(0,3)"
              :key="i"
            >
              <router-link class="" :to="'/blog/' + popularpost.dash + '/' + popularpost.mask" style="display:flex">
              <div>
                <img
                  :src="popularpost.image"
                  height="50px"
                  width="50px"
                  style="border-radius:5px;"
                  class
                />
              </div>
              <div class="cat-det" style="padding-left:1rem">
                <span>{{popularpost.title}}</span>
                <br />

                <p class="blogDetails" style="margin-top:0.2rem"></p>
              </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-md-1"></div>

        <div class="col-md-8">
          <div class="row" style="display:flex">
            <div class="col-md-6 pb-5" v-for="(post, i) in blogPosts.posts" :key="i">
              <router-link class="blogbox" :to="'/blog/' + post.dash + '/' + post.mask">
                <div class="blog-card mb-5">
                  <div class="blog-card-img" v-on:click="navigateToPost(post.dash, post.mask)">
                    <img :src="post.image" :alt="post.title" />
                  </div>

                  <div class="card blog-card-content">
                    <!-- <small class="d-block text-secondary mb-2">{{ post.date_craeted }}</small> -->
                    <h2 class="h5 mb-3 blogTitle" style="color:#505050">{{ post.title }}</h2>
                    <p class="blogDetails">
                      <!-- <span
                        style="margin-right:0.5em; font-style: italic;"
                      >{{ post.date_created }} By</span>-->
                      <!-- <span style="font-weight:bold">Lesley London</span> -->
                    </p>

                    <p v-html="post.description" class="desc"></p>
                    <!-- <div class="blogCon" style="margin-top:1rem">
                      <div class="commentInfo" style="display:flex" >
                        
                     
                      </div>
                      <small class="commentcount" >{{ post.commentscount }} comments</small>
                    </div>-->
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" v-if="!postsContentLoaded">
        <div class="col-md-3">
          <div class="fake-post-item">
            <div class="fake-content animated-background mb-2"></div>
            <div class="fake-content animated-background mb-2"></div>
          </div>
        </div>
        <div class="col-sm-6 col-md-3" v-for="(items, i) in fakeItems" :key="i">
          <blogfakeitem></blogfakeitem>
        </div>
      </div>
    </div>

    <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>

<script>
var blogImg = require("../../assets/img/blog.png");
var adminImg = require("../../assets/img/user.png");
var calenderImg = require("../../assets/img/calender.png");
var chatImg = require("../../assets/img/chat.png");
var eyeImg = require("../../assets/img/eye.png");
import CoreValues from "../../components/Core.vue";

import BlogPostsfakeItem from "../../components/BlogPostsfakeItem.vue";

import axios from "axios";

export default {
  components: {
    blogfakeitem: BlogPostsfakeItem,

    core: CoreValues
  },
  name: "Posts",
  metaInfo: {
    title: "Blog"
  },
  data() {
    return {
      bannerTitle: "Blog",

      blogImg: blogImg,
      adminImg: adminImg,
      chatImg: chatImg,
      eyeImg: eyeImg,
      searchwords: null,
      calenderImg: calenderImg,
      fakeItems: 2,
      postsContentLoaded: false,
      blogPosts: [],
      categoryData: []
    };
  },
  methods: {
    search(e) {
      this.$router.push("/blogsearch/" + this.searchwords);
    },
    async fetchBlogPosts() {
      let posts = await axios.get(APIURL + "blog");
      this.blogPosts = posts.data;
      this.postsContentLoaded = true;
    },

    navigateToPost(dash, mask) {
      this.$router.push({ path: `/blog/${dash}/${mask}` });
    }
  },
  created() {
    this.fetchBlogPosts();
  }
};
</script>
